import { EViewSolarEstimationSolarProductCategory } from "../enums/view-solar-estimation-solar-product-category";

export const filterByCategories = <
  T extends { product: { category: EViewSolarEstimationSolarProductCategory } }
>(
  items: T[],
  categories: readonly EViewSolarEstimationSolarProductCategory[]
) =>
  items
    .filter((i) => categories.includes(i.product.category))
    .sort(
      (a, b) =>
        categories.indexOf(a.product.category) -
        categories.indexOf(b.product.category)
    );
